let isInDebugMode = true; // Default to true
let listeners: ((debugMode: boolean) => void)[] = [];

// Function to get debug mode (for external use)
export const getDebugMode = () => isInDebugMode;

// Function to update debug mode (can be used by React Context)
export const setDebugMode = (newValue: boolean) => {
  isInDebugMode = newValue;
  listeners.forEach((callback) => callback(isInDebugMode));
};

// Allow external functions to listen for updates
export const subscribeToDebugMode = (
  callback: (debugMode: boolean) => void
) => {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((listener) => listener !== callback);
  };
};
